// import React from 'react'
// import NavDropdown from 'react-bootstrap/NavDropdown';
// import { Link, navigate, useNavigate } from 'react-router-dom';
// import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
// import logo1 from '../../Assets/milk.jpg'
// import logo2 from '../../Assets/milklogo.webp'
// import AdminNav from '../../AdminNav';
// const AdminHeader = () => {

//   const navigate = useNavigate();

//   const backToMainPage = () => {
//     sessionStorage.clear();
//     navigate('/')
//   }

//   const userdata = JSON.parse(sessionStorage.getItem('userdata'));
//     const branchId = userdata.branch_id;
//     const email = userdata ? userdata.email_id : '';

 
//   return (


//   <Container fluid className='m-0 p-0 ' >

//   <div className='m-0 p-0 '>
//   <div>
//   <AdminNav />
//   </div>

// <Container fluid>
//   <Navbar  expand="lg" style={{backgroundImage:" linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )"}} >
 
//   {/* <Navbar.Brand  className='ps-md-5'><img   alt="" width={150} height={40}/></Navbar.Brand> */}
//   {/* <Navbar.Brand  className='ms-md-5 text-center ps-md-3'><h3 className='bolder' style={{fontFamily:"cursive",marginBottom:"0px"}}>Gavali</h3></Navbar.Brand> */}
//   <Navbar.Toggle aria-controls="navbarScroll" />
//   <Navbar.Collapse id="navbarScroll">
//   <Nav
//     className="ms-auto my-2 my-lg-0  fw-bolder" style={{fontSize:"14px",fontFamily:"monospace"}}>

//       <Nav.Link href="/#/adminDashboard"  className='mx-2' style={{color:"black"}}>Dashboard</Nav.Link>
      
//       <NavDropdown className='mx-2' title={<span style={{ color:"black" }} >Master</span>} id="basic-nav-dropdown">
//         <NavDropdown.Item href="/#/productMaster">Product Master</NavDropdown.Item>
//         <NavDropdown.Item href="/#/customerMaster">Customer Master</NavDropdown.Item>
//         <NavDropdown.Item href="/#/deliveryBoy">Employee Master</NavDropdown.Item>
//       </NavDropdown>

//       <NavDropdown className='mx-2' title={<span style={{ color: 'Black' }}>Transaction</span>}  id="basic-nav-dropdown">
//       <NavDropdown.Item href="/#/orderBoyToCustomer">Employee To Customer Allotment</NavDropdown.Item>
//         <NavDropdown.Item href="/#/orderAllotment">Order Allotment</NavDropdown.Item>
//         <NavDropdown.Item href="/#/dailyStock">Daily Stock</NavDropdown.Item>
//       </NavDropdown>

//         <Nav.Link
//       href="/#/adminBilling"
//         className='mx-2' style={{color:"black"}}>Billing Process</Nav.Link>

//         <Nav.Link
//       href="/#/payment"
//         className='mx-2' style={{color:"black"}}>Payment</Nav.Link>

//       <Nav.Link
//       // href="/#/adminReport"
//         onClick={backToMainPage}
//         className='mx-2'><i class="fa-solid fa-right-from-bracket" style={{color:"rgb(254, 105, 129)"}}></i></Nav.Link>
//   </Nav>
//   </Navbar.Collapse>
  
//   </Navbar>
//   </Container>
//   </div>
  

//   <Row className='m-0 p-0 fixed-bottom   py-1' style={{backgroundImage:" linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )" ,display:"flex",justifyContent:"center",alignContent:"center",fontFamily:"monospace",color:"black"}}>
//   <h6 className='text-center text-dark'>2023 DESIGN & DEVELOPED BY | TechnoAarv Solution</h6>
//   </Row>
  
//   </Container>



//   )
// }

// export default AdminHeader




import React, { useEffect } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import AdminNav from '../../AdminNav';
import logo1 from '../../Assets/milk.jpg';

const AdminHeader = () => {
  const navigate = useNavigate();

  const backToMainPage = () => {
    sessionStorage.clear();
    navigate('/');
  };

  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const email = userdata ? userdata.email_id : '';

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (window.scrollY > 100) {
        navbar.classList.add("fixed-top", "fixed-background");
      } else {
        navbar.classList.remove("fixed-top", "fixed-background");
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Container fluid className='m-0 p-0 '>
      <div className='m-0 p-0 '>
        <div>
          <AdminNav />
        </div>
        
        <Container fluid>
          {/* <Navbar expand="lg" style={{ backgroundImage: "linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )" }}> */}
          <Navbar expand="lg" style={{ backgroundColor:"rgb(47, 79, 79)" }}>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
            <Nav
    className="ms-auto my-2 my-lg-0  fw-bolder" style={{fontSize:"14px",fontFamily:"monospace"}}>

      <Nav.Link href="/#/adminDashboard"  className='mx-2' style={{color:"white"}}>Dashboard</Nav.Link>
      
      <NavDropdown className='mx-2' title={<span style={{ color:"white" }} >Master</span>} id="basic-nav-dropdown">
        <NavDropdown.Item href="/#/productMaster">Product Master</NavDropdown.Item>
        <NavDropdown.Item href="/#/customerMaster">Customer Master</NavDropdown.Item>
        <NavDropdown.Item href="/#/deliveryBoy">Employee Master</NavDropdown.Item>
      </NavDropdown>

      <NavDropdown className='mx-2' title={<span style={{ color: 'white' }}>Transaction</span>}  id="basic-nav-dropdown">
      <NavDropdown.Item href="/#/orderBoyToCustomer">Employee To Customer Allotment</NavDropdown.Item>
        <NavDropdown.Item href="/#/orderAllotment">Order Allotment</NavDropdown.Item>
        <NavDropdown.Item href="/#/dailyStock">Daily Stock</NavDropdown.Item>
      </NavDropdown>

        <Nav.Link
      href="/#/adminBilling"
        className='mx-2' style={{color:"white"}}>Billing Process</Nav.Link>

        <Nav.Link
      href="/#/payment"
        className='mx-2' style={{color:"white"}}>Payment</Nav.Link>

      {/* <Nav.Link
      // href="/#/adminReport"
        onClick={backToMainPage}
        className='mx-2'><i class="fa-solid fa-right-from-bracket" style={{color:"rgb(254, 105, 129)"}}></i></Nav.Link> */}
  </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </div>
      <Row className='m-0 p-0 fixed-bottom   py-1' style={{ backgroundColor:"rgb(47, 79, 79)", display: "flex", justifyContent: "center", alignContent: "center", fontFamily: "monospace", color: "white" }}>
        <h6 className='text-center '>2023 DESIGN & DEVELOPED BY | TechnoAarv Solution</h6>
      </Row>
    </Container>
  );
};

export default AdminHeader;
